export default __webpack_public_path__ + "static/tokens-6a2accfb73d23b0b19c153424021b4ee.png";